import type { MemberPasswordResetCreateFormFieldProps, MemberPasswordResetCreateFormProps } from '@vista-digital/occ-ui'
import { MemberPasswordResetCreateFormFieldName } from '@vista-digital/occ-ui'
import { defaultMemberPasswordResetCreateFormProps } from '@vista-digital/occ-ui/src/lib/components/member/password-reset-create-form/types/props'
import type { NestedPartial } from '@vista-digital/utilities'
import type { MemberPasswordResetFormProps } from '@/common/components/signInForm/memberPasswordResetForm/MemberPasswordResetForm'
import type { MemberSignInFormPropsApi } from '@/common/components/signInForm/memberSignInForm/models'

export const passwordResetProps = (
    props: MemberPasswordResetFormProps & { captchaEnabled?: boolean }
): NestedPartial<MemberPasswordResetCreateFormProps> => {
    const { displayText, events } = props
    return {
        ...defaultMemberPasswordResetCreateFormProps,
        displayText,
        config: {
            validation: {
                captcha: {
                    required: !!props?.captchaEnabled,
                },
            },
        },
        events,
    }
}

export const getIdentifierFieldProps = (props: MemberSignInFormPropsApi): MemberPasswordResetCreateFormFieldProps => {
    return {
        name: MemberPasswordResetCreateFormFieldName.Identifier,
        displayText: {
            label: props.emailLabel,
            placeholder: props.emailLabel,
            requiredMessage: props.emailRequiredMessage,
        },
    }
}
